import { createBrowserHistory } from "history";
import { paths } from "./common/constants/Rutas";

export default createBrowserHistory({basename: paths.basename});